import { ISavedView } from '@opengov/reporting-types/src/reportSavedView';
import { produce } from 'immer';

import { composeStateMachine } from '../../../../module';

export enum SavedViewsStatus {
  Loading = 'loading',
  Updating = 'updating',
  Current = 'current'
}

export interface ISavedViewState {
  savedViews: ISavedView[];
  savedViewsStatus: SavedViewsStatus;
  selectedSavedViewId?: string;
  clean?: boolean;
  embedCreateQueue?: ISavedView[];
}

export const SavedViewInitialState = {
  savedViews: [],
  savedViewsStatus: SavedViewsStatus.Loading,
  selectedSavedViewId: null,
  clean: true,
  embedCreateQueue: []
};

export const savedViewState = composeStateMachine('saved-views', SavedViewInitialState, (compose) => ({
  loadSavedViews: compose.payloadlessAction((state) =>
    produce(state, (newState) => {
      newState.savedViewsStatus = SavedViewsStatus.Loading;
    })
  ),

  setSavedViewStatus: compose.action((state, status: SavedViewsStatus) =>
    produce(state, (newState) => {
      newState.savedViewsStatus = status;
    })
  ),

  loadSavedViewsSuccess: compose.action((state, payload: ISavedView[]) =>
    produce(state, (newState) => {
      newState.savedViewsStatus = SavedViewsStatus.Current;
      newState.savedViews = payload;
    })
  ),

  loadSavedViewsError: compose.payloadlessAction((state) =>
    produce(state, (newState) => {
      newState.savedViewsStatus = SavedViewsStatus.Current;
    })
  ),

  selectSavedView: compose.action((state, payload: ISavedView) =>
    produce(state, (newState) => {
      newState.selectedSavedViewId = payload ? payload.id : null;
    })
  ),

  createSavedViewError: compose.action((state, _error: any) =>
    produce(state, (newState) => {
      newState.savedViewsStatus = SavedViewsStatus.Current;
    })
  ),

  queueSavedViewEmbed: compose.action((state, payload: ISavedView) =>
    produce(state, (newState) => {
      newState.embedCreateQueue.push(payload);
    })
  ),

  dequeueSavedViewEmbed: compose.action((state, payload: ISavedView) =>
    produce(state, (newState) => {
      newState.embedCreateQueue = newState.embedCreateQueue.filter((sv) => sv.id !== payload.id);
    })
  )
}));

export const {
  actions: savedViewActions,
  actionCreators: savedViewActionCreators,
  reducer: savedViewReducer,
  selector: savedViewSelector
} = savedViewState;
